<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-model="query.sourceId" placeholder="请选择来源" @change="getData" style="width: 200px; margin-right: 10px;">
					<el-option v-for="item in sourceList" :key="item.id" :label="item.sourceName" :value="item.id"></el-option>
				</el-select>
				<el-button size="small" type="primary" :class="[theme]" @click="handleAdd" v-if="isAdmin">添加套餐</el-button>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe v-loading="loading">
				<el-table-column prop="sourceName" label="来源名称" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="dxtPackageName" label="迪信通套餐名" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="channelPackageName" label="渠道套餐名" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="createdAt" label="创建时间" align="center" width="160"></el-table-column>
				<el-table-column label="操作" width="190" align="center">
					<template #default="scope">
						<el-button size="small" type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
							@click="handleDelete(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :title="title" v-model="addVisible" width="520px" @close="closeDialog">
			<el-form label-width="130px" :model="addForm" ref="editForm">
				<el-form-item label="来源" prop="sourceId">
					<el-select size="small" v-model="addForm.sourceId" placeholder="请选择来源" style="width: 100%;" :disabled="title == '修改'">
						<el-option v-for="item in sourceList" :key="item.id" :label="item.sourceName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="迪信通套餐名" prop="dxtPackageName">
					<el-input size="small" v-model="addForm.dxtPackageName" placeholder="请输入迪信通套餐名"></el-input>
				</el-form-item>
				<el-form-item label="渠道套餐名" prop="channelPackageName">
					<el-input size="small" v-model="addForm.channelPackageName" placeholder="请输入渠道套餐名"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="title == '添加'"
						@click="submitAdd">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="title == '修改'"
						@click="submitUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getDijiaNumberPoolPackageList,
		addDijiaNumberPoolPackage,
		updateDijiaNumberPoolPackage,
		deleteDijiaNumberPoolPackage,
		getDijiaNumberPoolSourceList
	} from '../api/dijia.js';
	export default {
		name: 'DijiaNumberPoolPackage',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					sourceId: ''
				},
				title: '添加',
				tableData: [],
				sourceList: [],
				addForm: {
					sourceId: '',
					dxtPackageName: '',
					channelPackageName: ''
				},
				addVisible: false,
				isAdmin: false,
				isCompany: false,
				isAgent: false
			};
		},

		created() {
			let role = localStorage.getItem('ms_role');
			if (role === 'company') {
				this.isCompany = true;
			}
			if (role === 'admin') {
				this.isAdmin = true;
			}
			if (role === 'agent') {
				this.isAgent = true;
			}
			this.getSourceList();
			this.getData();
		},
		methods: {
			getSourceList() {
				getDijiaNumberPoolSourceList().then(res => {
					if (res?.code === 200) {
						this.sourceList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getData() {
				if (!this.query.sourceId) {
					this.tableData = [];
					return;
				}
				this.loading = true;
				getDijiaNumberPoolPackageList(this.query.sourceId).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleAdd() {
				if (!this.query.sourceId) {
					this.$message.error('请先选择来源');
					return;
				}
				this.title = '添加';
				this.addVisible = true;
				this.addForm = {
					sourceId: this.query.sourceId,
					dxtPackageName: '',
					channelPackageName: ''
				};
			},
			handleEdit(row) {
				this.title = '修改';
				this.addVisible = true;
				this.addForm = {
					id: row.id,
					sourceId: row.sourceId,
					dxtPackageName: row.dxtPackageName,
					channelPackageName: row.channelPackageName
				};
			},
			submitAdd() {
				if (!this.addForm.sourceId) {
					this.$message.error('来源不能为空');
					return;
				}
				if (!this.addForm.dxtPackageName) {
					this.$message.error('迪信通套餐名不能为空');
					return;
				}
				let data = {
					sourceId: this.addForm.sourceId,
					dxtPackageName: this.addForm.dxtPackageName,
					channelPackageName: this.addForm.channelPackageName
				};
				addDijiaNumberPoolPackage(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('添加成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.addVisible = false;
				});
			},
			submitUpload() {
				let data = {
					id: this.addForm.id,
					dxtPackageName: this.addForm.dxtPackageName,
					channelPackageName: this.addForm.channelPackageName
				};
				updateDijiaNumberPoolPackage(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('修改成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.addVisible = false;
				});
			},
			closeDialog() {
				this.addVisible = false;
			},
			handleDelete(row) {
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						deleteDijiaNumberPoolPackage(row.id).then(res => {
							if (res?.code === 200) {
								this.$message.success('删除成功');
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}
</style>
